// extracted by mini-css-extract-plugin
export var border = "HeaderNavItem-module--border--3ebfe";
export var cdsAssistiveText = "HeaderNavItem-module--cds--assistive-text--431eb";
export var cdsHideFeedback = "HeaderNavItem-module--cds--hide-feedback--5f4c3";
export var cdsShowFeedback = "HeaderNavItem-module--cds--show-feedback--6d6dd";
export var cdsSkeleton = "HeaderNavItem-module--cds--skeleton--378a2";
export var cdsVisuallyHidden = "HeaderNavItem-module--cds--visually-hidden--cd946";
export var currentPage = "HeaderNavItem-module--currentPage--39eda";
export var currentPageAccordion = "HeaderNavItem-module--currentPageAccordion--5219c";
export var menuItem = "HeaderNavItem-module--menuItem--e91b0";